import apiService from "./api";

export interface CouponPreviewResponse {
  original_price: number;
  discount_amount: number;
  final_price: number;
  coupon_applied: boolean;
}

export interface Coupon {
  id: number;
  code: string;
  discount_type: string;
  discount_value: number;
}

export const couponService = {
  async preview(
    planId: string,
    couponCode: string | null,
    planTypeId?: number
  ): Promise<CouponPreviewResponse> {

    return await apiService.post<CouponPreviewResponse>(
      "/coupon/preview",
      {
        plan_id: planId,
        coupon_code: couponCode ? couponCode.trim() : null,
        plan_type_id: planTypeId || null,
      }
    );
  },

  async getAvailableCoupons(userId?: string): Promise<Coupon[]> {
    const query = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    return await apiService.get<Coupon[]>(
      `/coupon/available${query}`
    );
  }
};